import React, { useEffect, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import "../css/elements-css/NewLatestPop.css";
import PopupImg1 from "./../assets/img/Disclosur.png";
import PopupImg2 from "./../assets/img/popup-2.jpg"; // New image

const NewsletterPopup = () => {
  const [popupIndex, setPopupIndex] = useState(0); // 0 = first, 1 = second
  const [isVisible, setIsVisible] = useState(true);

  const togglePopup = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (popupIndex === 0) {
        setPopupIndex(1); // Show second popup
        setIsVisible(true); // Show it again
      } else {
        setIsVisible(false); // Hide after second popup
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, [popupIndex]);

  return (
    <div>
      {isVisible && (
  <div className={`popup ${popupIndex === 1 ? "no-bg" : ""}`}>
    <div className={`popup-content ${popupIndex === 1 ? "no-bg" : ""}`}>
      <div className="iconDiv">
        <AiFillCloseCircle className="croseIcon" onClick={togglePopup} />
      </div>
      <img
        src={popupIndex === 0 ? PopupImg1 : PopupImg2}
        alt={`popup-${popupIndex + 1}`}
      />
            <a 
              href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html" 
              className="text-center text-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html
            </a>
    </div>
  </div>
)}
    </div>
  );
};

export default NewsletterPopup;
